<template>
  <div style="width: 95%;">
    <template v-if="loading">
          <Loader :delay="0"></Loader>
    </template>
    <template v-else>
      <b-form>
        <b-row>
          <b-col>
              <b-form-group style="font-size: 1rem;" label="IDI">
                <b-form-input :value="feature.id.split('.')[1]" disabled></b-form-input>
              </b-form-group>
          </b-col>
          <b-col>
              <b-form-group style="font-size: 1rem;" label="Código">
                <b-form-input v-model="feature.properties.building_id" disabled></b-form-input>
              </b-form-group>
          </b-col>
          <b-col>
              <b-form-group style="font-size: 1rem;" label="Status Modificado">
                <b-form-input :value="feature.properties.modified_status" disabled></b-form-input>
              </b-form-group>
          </b-col>
          <b-col>
              <b-form-group style="font-size: 1rem;" label="ID Área Lote">
                <b-form-input :value="feature.properties.lot_area_id" disabled></b-form-input>
              </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Provincia">
              <b-form-input :value="feature.properties.nombre_provincia_zeus" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Municipio">
              <b-form-input :value="feature.properties.nombre_municipio_zeus" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Población">
              <b-form-input :value="feature.properties.nombre_poblacion_zeus" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            <b-form-group style="font-size: 1rem;" label="Tipo Entidad Población">
              <b-form-input :value="feature.properties.tipo_entidad_zeus" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group style="font-size: 1rem;" label="Código Vía">
              <b-form-input :value="feature.properties.cod_street_gas" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Dirección postal">
              <b-form-input :value="feature.properties.name_type + ' ' + feature.properties.street_name + ' ' + feature.properties.building_number + ' ' + (feature.properties.additional_annex||'')" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group style="font-size: 1rem;" label="Código postal">
              <b-form-input :value="feature.properties.zip_code" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Distancia a Red Dist. en servicio (m)">
              <b-form-input :value="feature.properties.in_service_mains_distance" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Distancia a Red Dist. no abandonada (m)">
              <b-form-input :value="feature.properties.not_abandoned_mains_distance" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Distancia a Red AP en servicio (m)">
              <b-form-input :value="feature.properties.high_press_main_in_service_dis" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Distancia a Red AP no abandonada (m)">
              <b-form-input :value="feature.properties.high_pressure_mains_distance" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Precisión coordenada">
              <b-form-input :value="feature.properties.precision_coordenada" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Parcela catastral">
              <b-form-input :value="feature.properties.parcela_catastral" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Excención derechos alta">
              <b-form-input :value="feature.properties.exemption_register_rights" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Latitud">
              <b-form-input :value="feature.properties.coordinate_y" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Longitud">
              <b-form-input :value="feature.properties.coordinate_x" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="EPSG">
              <b-form-input :value="feature.properties.epsg" disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group style="font-size: 1rem;" label="Exención Canon">
              <b-form-input :value="feature.properties.canon_type_id.canon_type_description || ''" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </template>
    </div>
</template>

<style></style>

<script>

import Loader from '@/components/Layout/Loader.vue';

export default {
  props: ['feature'],
  components: {Loader},
  data () {
    return {
      loading: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/DetailsResidencial/Identificacion.vue